module.exports = __webpack_public_path__ + "static/img/qianqingyichang.151c253a.png";